import axios from "./axios-auth";

const GetUsersByClients = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/hr-adm/getusersbyclients",
      data: payload,
      method: "POST",
    })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        console.log("error in GetUsersByClients" + err);
      });
  });

const SendEmailToUsers = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/hr-adm/sendemailtousers",
      data: payload,
      method: "POST",
    })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        console.log("error in SendEmailToUsers" + err);
      });
  });

export { GetUsersByClients, SendEmailToUsers };
